var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_empty_rating.b73b410d.png","uri@2x": __webpack_public_path__ + "static/media/img_empty_rating.d0724c37.png","uri@3x": __webpack_public_path__ + "static/media/img_empty_rating.85de7988.png",
    width: 280,
    height: 280
});